import axios from 'axios';
import { createCancelToken, CancelCallback, Result, errorResult } from '../apiActions';
import { COMPLIANCE_KB_TOKEN_PATH } from '../constants';

type EmbedTokenResponse = {
  /** JWT HS256 de vida curta (~60s), assinado pelo nosso backend. */
  token: string;
};

/**
 * Busca no nosso backend um JWT recém-assinado para abrir o chat de Compliance.
 *
 * Usa a instância default do axios de propósito: ela já carrega o baseURL e o
 * interceptor que injeta o Authorization com renovação (lib/config/configureAxios),
 * então o Bearer da sessão vai junto sem nada extra aqui.
 *
 * O token é de uso único e expira em ~60s, então precisa ser buscado no momento
 * de entregar para o widget — nunca cacheado nem reaproveitado.
 */
export async function getEmbedToken(
  cancelCallback?: CancelCallback
): Promise<Result<EmbedTokenResponse>> {
  const cancelToken = createCancelToken(cancelCallback);

  try {
    const { status, data } = await axios.get<EmbedTokenResponse>(COMPLIANCE_KB_TOKEN_PATH, {
      cancelToken,
    });

    return { ok: true, status, data };
  } catch (error) {
    return errorResult(error);
  }
}
